import Svg from '@justgiving/svg';
import classNames from 'classnames';
import React, { useState } from 'react';
import { FunctionComponent } from 'react';
import styles from './GiftAidBanner.scss';
import { closeIcon } from '@justgiving/icons';
import { useSupportsGiftAid } from '../../hooks/page/useSupportsGiftAid';

const GiftAidBanner: FunctionComponent = () => {
  const [isClosed, setIsClosed] = useState(false);

  const { data } = useSupportsGiftAid();

  const showBanner = !isClosed && data?.page?.supportsGiftAid;

  return showBanner ? (
    <div
      className={classNames(
        `${styles.informationBanner} jg-display-flex jg-flex-aic jg-space-psm jg-space-mvsm jg-background--white-smoke`,
      )}
    >
      <div className={classNames('jg-space-mrsm')}>
        <span className={styles.giftAidIcon} />
      </div>
      <div>
        By adding Gift Aid, the charity gets 25p for every £1 at
        <strong> no extra cost to you</strong>
      </div>
      <Svg
        markup={closeIcon}
        aria-label={'closeIcon'}
        className={styles.closeIcon}
        onClick={() => setIsClosed(true)}
      />
    </div>
  ) : null;
};

export default GiftAidBanner;
